<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view/>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return{
      isRouterAlive: true,                    //控制视图是否显示的变量
      title: localStorage.getItem('title') || '车贷在线'
    }
  },
  mounted () {
    document.body.addEventListener('touchstart', function () { });
  },
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
    return {
      reload: this.reload                                              
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
          this.isRouterAlive = true;         //再打开
      }) 
    }
  },
  // watch: {
  //   // 兼容ios刷新title
  //   $route: {
  //     handler: function(val){
  //       if(this.title !== val.meta.title) {
  //         window.localStorage.setItem('title', val.meta.title)
  //         if(navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
  //           location.reload()
  //         }
  //       }
  //     },
  //     // 深度观察监听
  //     deep: true
  //   }
  // }
}
</script>
